import { financeAPI } from "../../axios"
export const actions = {
  createBurs(context, data) {
    return financeAPI.post("Burs/Create", data);
  },
  getSingleBurs(context, id) {
    return financeAPI.get(`Burs/${id}`);
  },
  updateBurs(context, data) {
    return financeAPI.put(`Burs/${data.id}`, data);
  },
  deleteBurs(context, id) {
    return financeAPI.delete(`Burs/${id}`);
  },
  postBurs(context, data) {
    return financeAPI.put(`Burs/Post/${data.id}`, data);
  },
  approveBurs(context, id) {
    return financeAPI.put(`Burs/Approve/${id}`);
  },
  returnBurs(context, id) {
    return financeAPI.put(`Burs/Return/${id}`);
  },
  getPendingBurs(context, { cycle, campusId }) {
    return financeAPI.get(`Burs/Pending/${cycle}/${campusId}`);
  },
  getPostedBurs(context, { cycle, campusId }) {
    return financeAPI.get(`Burs/Posted/${cycle}/${campusId}`);
  },
  getApprovedBurs(context, { cycle, campusId }) {
    return financeAPI.get(`Burs/Approved/${cycle}/${campusId}`);
  },
  getAvailable(context, { cycle, campusId }) {
    return financeAPI.get(`Burs/Available/Rfp/${cycle}/${campusId}`);
  },
};
